export default "__VITE_ASSET__BMO0tPWb__"